import linkToCodeEditor from 'toxilibs/link_to_code_editor.js'
import developmentEnvironment from './development_environment.js'
import launch from './chef.js'

import './translations_manager.js'
import './game.js'
import './remote_challenge.js'
import './ui/main.js'
import './world_user_controls/controls.js'

//import './world_user_controls/controls_with_mouse.js'

import './world_user_controls/controls_with_swipe.js'
import './sound/sounds.js'
import './stats.js'
import './get_stats_data.js'


if (developmentEnvironment) {
    linkToCodeEditor.setAbsolutePath('/Users/plancien/dev/toxicode/pedagogie/compute_it/')
}


launch()
